import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Role } from './RoleApi';
import { fetchAllRoles, deleteRole } from './RoleApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';  


const RoleList: React.FC = () => {
  const [roles, setRoles] = useState<Role[]>([]);

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    const res = await fetchAllRoles();
    setRoles(res.data);
  };

  const handleDelete = async (id: string) => {
    if (window.confirm('Are you sure?')) {
      await deleteRole(id);
      loadRoles();
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-semibold">Roles</h2>
        <Link
          to="/admin/roles/create"
          className="bg-indigo-600 text-white px-4 py-2 rounded"
        >
          Add Role
        </Link>
      </div>
      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th className="border px-4 py-2">Name</th>
            <th className="border px-4 py-2">Description</th>
            <th className="border px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {roles.map((role) => (
            <tr key={role.id}>
              <td className="border px-4 py-2">{role.name}</td>
              <td className="border px-4 py-2">{role.description}</td>
              <td className="border px-4 py-2 space-x-2">
  <Link
    to={`/admin/roles/${role.id}/view`}
    className="text-green-600 hover:underline"
  >
    <FontAwesomeIcon icon={faEye} />
  </Link>
  <Link
    to={`/admin/roles/${role.id}/edit`}
    className="text-blue-600 hover:underline"
  >
    <FontAwesomeIcon icon={faEdit} />
  </Link>
  <button
    onClick={() => handleDelete(role.id!)}
    className="text-red-600 hover:underline"
  >
    <FontAwesomeIcon icon={faTrash} />
  </button>
</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoleList;